import { render, staticRenderFns } from "./new.participants.page.vue?vue&type=template&id=2a5a669a&"
import script from "./new.participants.page.vue?vue&type=script&lang=js&"
export * from "./new.participants.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports